module.exports = __webpack_public_path__ + "img/corrugatedBox3.41768780.jpg";